import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarMotorista(api, parametros) {
    parametros.operacao = 'buscarMotorista';

    let retorno = {};
    
    await api.santriGET('/rest/motorista', parametros, 20, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RMotorista.js